export default function nameof<T>(key: keyof T) {
    return key;
}

export function nameofMany<T,U>(key1: keyof T, key2: keyof U) {
    return `${key1}.${key2}`;
}


// WEBPACK FOOTER //
// ./src/utils/nameof.ts